import type {
  MarkAllNotificationsReadResponse,
  NotificationListParams,
  NotificationsResponse,
  NotificationUnreadCount,
} from "@facade/contracts";

import { api } from "@facade/api";

export const notificationsApi = {
  async getAll(params: NotificationListParams = {}) {
    const { data } = await api.get<NotificationsResponse>("/notifications", {
      params: {
        limit: params.limit,
        cursor: params.cursor,
        unread_only: params.unreadOnly,
        project_id: params.projectId,
      },
    });
    return data;
  },

  async getUnreadCount() {
    const { data } = await api.get<NotificationUnreadCount>(
      "/notifications/unread-count",
    );
    return data;
  },

  async markRead(notificationId: string) {
    await api.patch(`/notifications/${notificationId}/read`);
  },

  async markAllRead() {
    const { data } = await api.post<MarkAllNotificationsReadResponse>(
      "/notifications/read-all",
    );
    return data;
  },
};
